import { render } from "./blind-date.vue?vue&type=template&id=64259c6a&scoped=true"
import script from "./blind-date.vue?vue&type=script&lang=js"
export * from "./blind-date.vue?vue&type=script&lang=js"

import "./blind-date.vue?vue&type=style&index=0&id=64259c6a&scoped=true&lang=css"

import exportComponent from "D:\\yiban\\WebProject\\yiban-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64259c6a"]])

export default __exports__